(function ($) {
    $(document).ready(function () {
        $('.js-iframe-wrapper iframe').width($(window).width());
        $('.mapped-route__iframe-wrapper iframe').height('700');
        $(window).resize(function () {
            $('.js-iframe-wrapper iframe').width($(this).width());
        });
    });
})(jQuery);